(function ($, Drupal) {

  // Card G (feature on product display) toggle.
  Drupal.behaviors.featureToggle = {
    attach: function (context, settings) {

      $('.card--G', context).once('featureToggle').each(function () {

        let $el = $(this),
          $heading = $el.find('.card__heading'),
          $text = $el.find('.card__text'),
          $description = $el.find('.card__description'),
          $resPixel = $('.js_resolution');

        $text.next($description).addBack().wrapAll("<div class='js_cardToggle' />");

        $heading.on('click', function (evt) {

          evt.preventDefault();

          if ($resPixel.css('opacity') >= '0.5') {
            return false;
          }

          let $this = $(this),
              $featureDesc = $this.siblings('.js_cardToggle');

          if (!$featureDesc.hasClass('is_active')) {
            $this.addClass('is_active');
            $featureDesc.addClass('is_active');
          } else {
            $this.removeClass('is_active');
            $featureDesc.removeClass('is_active');
          }
        });

      });

    }
  };

})(jQuery, Drupal);
